import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DECISION_MAKERS_LEGISLATIVE_BODIES = createFcmDetails('decision_makers_legislative_bodies', {
	owner: 'Capybara',
	context:
		'On the petition page DM section, controls whether that UI/UX is anchored around legislative bodies and the Sunrise look',
	description: 'When false, DM section uses current UI/UX without groupped DMs and also without Sunrise look',
	import: false,
	mergeLogic: 'Displays a combined country & locale if either is set, otherwise global value is used',
});
